<template>
	<div>
		<div class="game game--mnemo" v-show="!reaction">
			<div class="train__info train__info--mb">
				<div class="train__item" v-if="params.finish" uk-tooltip="Ошибок сделано">
					<div class="train__ico train__ico--2"></div>
					<small>Ошибок:</small>
					{{ errors }}
				</div>
				<div class="train__item" v-if="$route.params.isHomework" uk-tooltip="Выполнено">
					<div class="train__ico train__ico--4"></div>
					<small>Выполнено:</small>
					<div class="train__nowrap">{{ $route.params.total }} из {{ $route.params.qnt }}</div>
				</div>
				<div class="train__item" uk-tooltip="Времени прошло">
					<div class="train__ico train__ico--3"></div>
					<div>
						<small>Времени прошло:</small>
						<!--<br class="uk-visible@s">-->
						{{ timer.minutes }} мин. {{ timer.seconds }} сек.
					</div>
				</div>
			</div>


			<div class="mnemo__wrap" :class="'mnemo__wrap--' + size">
				<ul class="mnemo__tab" :style="'grid-template: repeat(' + rows + ', 1fr) / repeat(' + columns + ', 1fr)'">
					<li v-for="el in field" :key="el.id" :class="el.class">
						<span></span>
					</li>
				</ul>
				<draggable
            v-show="!show_right"
					class="tables"
					:style="'grid-template: repeat(' + rows + ', 1fr) / repeat(' + columns + ', 1fr)'"
					:disabled="!params.start"
					:swap="true"
					tag="ul"
					swapClass="sortable-swap-highlight"
					v-model="readyImages"
					@end="checkFinishOpportunity">
					<li 
            class="tables__item" 
            v-show="element" 
            :class="(element && element.content) ? (element.content + (element.addClass ? ' ' + element.addClass : '')) : ''" 
            v-for="element in readyImages"
            :key="element.id"
          >
						<img :src="element.image" alt="" v-if="element && element.image">
					</li>
				</draggable>
        <draggable
            v-if="show_right"
            class="tables tables--right"
            :style="'grid-template: repeat(' + rows + ', 1fr) / repeat(' + columns + ', 1fr)'"
            :disabled="true"
            :swap="true"
            tag="ul"
            swapClass="sortable-swap-highlight">
          <li 
            class="tables__item" 
            v-show="element" 
            v-for="element in readyClone"
            :key="element.id"
          >
            <img :src="element.image" alt="" v-if="element && element.image">
          </li>
        </draggable>
				<!--<div class="mnemo__result" v-if="params.finish">
					<h3>{{ errors > 0 ? 'Упсс!' : 'Ты молодец!'}}</h3>
					<div class="train__intro">Результат:
						<span v-if="timer.minutes > 0">{{ timer.minutes }} минут</span> {{ timer.seconds }} секунд и {{ errors }} ошибок!
						<p class="scores">И ты зарабатываешь
							<strong>{{ scores }}</strong> {{ $root.getNoun(scores, 'балл', 'балла', 'баллов') }}!</p>
					</div>
				</div>-->
			</div>
			<div class="train__button">

				<div class="mnemo__result2" v-if="params.finish">
					<h3>{{ errors > 0 ? 'Упсс!' : 'Ты молодец!'}}</h3>
					<div class="train__intro">Результат:
						<span v-if="timer.minutes > 0">{{ timer.minutes }} минут</span> <strong>{{ timer.seconds }}</strong> секунд и <strong>{{ errors }}</strong> ошибок!
						<p class="scores">И ты зарабатываешь
							<strong>{{ scores }}</strong> {{ $root.getNoun(scores, 'балл', 'балла', 'баллов') }}!</p>
					</div>
          <a href="#" @click.prevent="show_right = !show_right"><span uk-icon="info"></span> {{ show_right ? 'Скрыть' : 'Показать' }} правильный вариант</a>
				</div>

				<button class="uk-button train__link" @click="letStart" v-if="!params.start && !params.finish">{{ params.start ? 'Время идет' : 'Я запомнил, готов начать!'}}</button>
				<button class="uk-button uk-button-primary" v-if="canFinish && !params.finish" @click="letFinish">Я собрал!</button>
				<button class="uk-button uk-button-primary" v-if="params.finish && !checkFinishHomework()" @click="letReStart">Повторить</button>
				<button class="uk-button uk-button-primary" @click="totalFinish" v-if="checkFinishHomework()">Закончить</button>
			</div>

			<a href="#" @click.prevent="totalFinish">Остановить</a>
		</div>

		<div class="wh-block wh-block--reaction" v-if="reaction">
			<div class="reaction">
				<!--<video loop muted preload="auto" autoplay>-->
				<video disableRemotePlayback preload="auto" autoplay @ended="stopReaction">
					<source type="video/mp4" :src="'/storage/app/media/reactions/' + reaction_file" id="mp4">
				</video>
			</div>
		</div>
	</div>
</template>

<script>
  import { mapState } from 'vuex';
  import draggable from 'vuedraggable/src/vuedraggable'
  import { mix } from "./../mixin";

  export default {
    name: "game",
    components: {
      draggable,
    },
    inject: ['http'],
    mixins: [
      mix
    ],
    data() {
      return {
        field: [],
        selectedImages: [],
        readyImages: [],
        readyClone: [],
        shuffledImages: [],
        errors: 0,
        show_right: false,
        first: true,
        getReady: false,
        canFinish: false,
        columns: '',
        rows: '',
        reaction: false,
        scores: 0,
      }
    },
    computed: {

      ...mapState({
        params: state => state.train.mnemo_params,
        size: state => state.train.mnemo_params.size * 1,
        trainer: state => state.current_trainer,
      }),

      finish() {
        return this.$store.state.train.mnemo_params.finish
      },
      user() {
        return this.$store.state.user;
      },
    },

    methods: {
      shuffle(array) {

        for (let i = array.length - 1; i > 0; i--) {
          let j = Math.floor(Math.random() * (i + 1));
          [array[i], array[j]] = [array[j], array[i]];
        }
        return array;
      },
      startGame() {
        this.getReady = true;
        this.startTimer();
      },
      letStart() {
        this.errors = 0;
        this.$parent.commitVal(true, 'start');
        //this.start = true;
        //this.createField();
        //this.selectImages();
        this.shuffleImages();
      },
      letReStart() {
        //this.finish = false;
        //this.start = false;
        setTimeout(function () {
          UIkit.scroll('.headline2').scrollTo('.train__info');
        }, 100);
        this.$parent.commitVal(false, 'start');
        this.$parent.commitVal(false, 'finish');
        this.canFinish = false;
        this.getReady = true;
        this.startTimer();
        this.createField();
        this.selectImages();
      },
      createField() {
        let fields = [];
        let position = 1;
        let el = {};
        let size = this.size;
        let columns = size + 2;
        let picBlocks = size * size;
        let minCells = picBlocks * 2;
        let rows;
        if (size == 3) {
          rows = size + 2;
        } else {
          rows = Math.ceil(minCells / columns);
        }
        //let rows = Math.ceil(minCells/columns) + 1;
        //let rows = 1;
        /*if(columns*rows < minCells){
					rows++;
				}*/

        /*do {
          console.log(minCells, columns*rows);
          rows = rows + 1;
        } while (minCells > (columns*rows));*/

        /*while (minCells > (columns*rows)){
					console.log(columns*rows, minCells);
					rows = rows + 1;
				}*/
        this.columns = columns;
        this.rows = rows;
        for (let row = 1; row < rows + 1; row++) {
          for (let column = 1; column < columns + 1; column++) {
            el = {
              'row': row,
              'column': column,
              'position': position
            };
            if (row == 1 || row == rows) {
              el.class = 'empty';
            } else {
              if (column == 1 || column == columns) {

                el.class = 'empty';
              } else {
                if (picBlocks > 0) {
                  el.class = 'table';
                  picBlocks--;
                } else {
                  el.class = 'empty';
                }
              }
            }
            fields.push(el);

            position++;
          }
        }

        this.field = fields;
      },
      selectImages() {
        let lim = this.size * this.size;
        let baseArr = this.trainer.images;
        let arr = this.shuffle(baseArr.slice(0)).slice(0, lim);
        let field = this.field;
        let setka = [];
        let selectImages = [];
        let position = 1;
        let imageNumber = 0;
        let el = {};

        field.forEach(function (item, i) {
          el = {};
          if (item.class == 'empty') {
            el.content = 'empty';
          } else {
            el.content = 'image';
            el.position = position;
            el.image = arr[imageNumber].path;
            imageNumber++;
            position++;
            selectImages.push(el);
          }
          setka.push(el);
        });
        this.readyImages = setka;
        this.readyClone = _.clone(setka);
        this.selectedImages = selectImages;
        //console.log(setka);
      },
      shuffleImages() {
        //console.log('Shuffle');
        let arr = this.shuffle(this.selectedImages.slice(0));
        let field = this.field;
        let pos = 0;
        let ret = [];
        let el = {};
        field.forEach(function (item, i) {
          el = {};
          if (item.class == 'empty') {
            if (arr[pos]) {
              ret.push(arr[pos]);
              pos++;
            } else {
              el.content = 'empty';
              ret.push(el);
            }
          } else {
            el.content = 'empty';
            ret.push(el);
          }
        });

        if (this.size == 5) {
          //console.log(pos, ret, arr[pos]);
          //ret.push(arr[pos]);
        }
        //console.log(ret);

        this.readyImages = ret;

      },
      checkFinishOpportunity() {
        //console.log('checkFinishOpportunity');
        let field = this.field;
        let arr = this.readyImages;
        let err = 0;
        field.forEach(function (item, i) {
          if (item.class == 'empty') {
            if (arr[i].content == 'image') err++;
          }
        });
        if (err > 0) {
          this.canFinish = false;
        } else {
          this.canFinish = true;
        }
      },
      letFinish() {
        //this.finish = true;
        //this.start = false;
        this.$parent.commitVal(false, 'start');
        this.$parent.commitVal(true, 'finish');
        this.checkErrors();
        this.addScores();
        this.makeStats();
        this.startReaction();
      },
      totalFinish() {
        this.$parent.commitVal(false, 'start');
        this.$parent.commitVal(false, 'get_ready');
        this.$parent.commitVal(false, 'finish');
        if (this.$route.params.isHomework) {
          this.$router.push({ name: 'student_homework' });
        }
      },
      checkErrors() {
        let arr = this.readyImages;
        let etalon = this.selectedImages;
        let pos = 0;
        let errors = 0;
        arr.forEach(function (item, i) {
          if (item.content && item.content == 'image') {
            let c_pos = item.position;
            let e_pos = etalon[pos].position;
            if (c_pos !== e_pos) {
              errors++;
              item.addClass = 'error';
            } else {
              item.addClass = 'success';
            }
            pos++;
          }
        });
        this.errors = errors;
      },
      /** РЕАКЦИИ */
      startReaction() {
        if (this.params.show_reactions) {
          let type = (this.errors === 0 ? 'react_plus' : 'react_minus');
          this.reaction_file = this.checkReaction(type);
          this.reaction = true;
        }
      },
      stopReaction() {
        this.reaction = false;
        let app = this;
        setTimeout(function () {
          UIkit.scroll('.headline2').scrollTo('.game');
          $('#repeat-' + app.inkey).focus();
        }, 100);
      },
      addScores() {
        let sum = 0;
        let total = (this.params.size*this.params.size)/2;
        
        if (this.errors <= total) {
          let scores = ((this.params.size * this.params.size) + (this.params.size * this.params.size)) * (1 - (this.errors / 10));

          sum = Math.ceil(scores);

          if(this.$route.params.isHomework){
            sum = Math.ceil(sum * this.$store.state.hw_coefficient);
          }
          this.checkScoreStatus(sum);
          this.scores = sum;
        } else {
          console.log('Слишком много ошибок');
        }
        this.$store.commit('changeUserScores', sum);
        console.log('Баллов заработано', sum);
      },
      async makeStats() {
        console.log("Make stats");
        if (this.user.role.code === 'student') {
          console.log('Бережно сохраняем статистику');
          let time = this.timer;
          let errors = this.errors;
          let train_params = this.params;
          let stats = {
            time: time,
            errors: errors,
            user_id: this.$store.state.user.id,
            trainer: this.$store.state.current_trainer.id,
            scores: this.scores,
            train_params: {
              size: +train_params.size
            }
          }
          stats = this.checkHomework(stats);
          let data = {
            'stat': stats
          }
          this.http.post('onSaveStats', data).then((res) => {
            this.checkCoins(res.data);
          });
          console.log(stats);

        } else {
          console.log('Учителей в статистику не заносим! Понятно?!');
        }
      },
    },
    mounted() {
      this.createField();
      this.selectImages();
      this.startTimer();
    },
    beforeDestroy() {
      this.totalFinish();
    }
  }
</script>

<style lang="scss">

</style>